module.exports = __webpack_public_path__ + "img/elf.4c38d471.svg";